import * as headerBlock from '../../header/';
import Thumbnail from '../../thumbnail';
import Uploading from '../../uploading';

const alert = require('vue-strap').alert;
const spinner = require('vue-strap').spinner;

export default {
  name: 'company-config',
  components: { headerBlock, alert, spinner, Thumbnail, Uploading },
  props: [
    'onLogout',
    'access_token',
    'authUser',
  ],
  mounted() {

  },
  data() {
    return {
      company: {
        id: null,
        name: '',
        picture: '',
        picture_url: '',
        logoff_after: ''
      },
      formData: {
        id: '',
        first_name: '',
        last_name: '',
        username: '',
        email: '',
        password: '',
        phone: '',
        confirmPassword: '',
        company: null,
        role: 'manager',
      },
      haveChanges: false,
      breadCrumbItems: [
        {
          text: 'Companies',
          to: `${process.env.START_URL}/companies`,
        }, {
          text: 'Add company',
          active: true,
        },
      ],
      processLoading: false,
      hasSaveError: false,
      needFill: false,
      alertError: {
        text: 'Some required fields are not filled',
        title: 'Error!',
        visible: false,
      },
      alertSuccess: {
        text: 'User created',
        title: 'Success!',
        visible: false,
      },
      upload: {
        total: 1,
        uploaded: 0,
        image: true,
        visible: false,
      },
    };
  },
  beforeRouteLeave(to, from, next) {
    if (this.haveChanges) {
      this.$refs.leavingConfirm.show();
      next(false);
    } else {
      next();
    }
  },
  methods: {
    minTotime(mins) {
      let hours = '';
      let minutes = '';
      if (mins > 1439) {
        hours = 23;
        minutes = 59;
      } else {
        hours = Math.floor(mins / 60);
        minutes = (mins - (hours * 60));
      }
      let result = (hours < 10 ? '0' + hours : hours);
      result += ':' + (minutes < 10 ? '0' + minutes : minutes);
      return result;
    },
    timeToMin(time) {
      const hours = parseInt(time.split(':')[0]);
      const minutes = parseInt(time.split(':')[1]);
      let result = (hours * 60 + minutes);
      return result;
    },
    discardChanges() {
      this.haveChanges = false;
      this.$router.push({
        name: this.$router.history.pending.name,
        params: this.$router.history.pending.params,
      });
    },
    getCompanyInfo(id) {
      function getFileNameFromUrl(url) {
        if (!url) return null;
        const name = url.split('/');
        return name[name.length - 1];
      }
      return this.$http.get(`companies/${id}/`,
        {
          method: 'GET',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log(response);
            this.processLoading = false;
            return;
          }
          this.company.id = response.body.id;
          this.company.name = response.body.name;
          this.company.picture_url = response.body.picture;
          this.company.picture_name = getFileNameFromUrl(response.body.picture);
          this.company.logoff_after = this.minTotime(response.body.logoff_after);
          if (response.body.manager) {
            this.formData.first_name = response.body.manager.first_name;
            this.formData.last_name = response.body.manager.last_name;
            this.formData.username = response.body.manager.username;
            this.formData.phone = response.body.manager.phone;
            this.formData.email = response.body.manager.email;
            this.formData.id = response.body.manager.id;
          }
          setTimeout(() => {
            this.haveChanges = false;
          }, 1);
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
        });
    },
    validateEmail(email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    validateData() {
      if (this.timeToMin(this.company.logoff_after) < 60) {
        this.alertError.text = 'Minimum logoff time is 01:00';
        this.alertError.visible = true;
        return false;
      }
      if (!this.company.name) {
        this.alertError.text = 'Please fill company name';
        this.alertError.visible = true;
        return false;
      }
      if (!this.formData.first_name) {
        this.alertError.text = 'Please fill first name';
        this.alertError.visible = true;
        return false;
      }
      if (!this.formData.last_name) {
        this.alertError.text = 'Please fill last name';
        this.alertError.visible = true;
        return false;
      }
      if (this.formData.email && !this.validateEmail(this.formData.email)) {
        this.alertError.text = 'Invalid Email';
        this.alertError.visible = true;
        return null;
      }
      if (!this.formData.username && !this.validateEmail(this.formData.email)) {
        this.alertError.text = 'Please fill Username or Email';
        this.alertError.visible = true;
        return null;
      }
      // if (!this.formData.username) {
      //   this.alertError.text = 'Please fill username';
      //   this.alertError.visible = true;
      //   return false;
      // }
      // if (!this.formData.first_name ||
      //     !this.formData.last_name ||
      //     !this.formData.username) {
      //   return false;
      // }
      if (this.formData.id && (this.formData.password.length !== 0 &&
          (this.formData.password !== this.formData.confirmPassword))) {
        this.alertError.text = "Passwords don't match";
        this.alertError.visible = true;
        this.needFill = true;
        return null;
      }
      if (!this.formData.id && this.formData.password.length === 0) {
        this.alertError.text = 'Password mandatory';
        this.alertError.visible = true;
        this.needFill = true;
        return null;
      }
      if (!this.formData.id && (this.formData.password.length === 0 ||
          (this.formData.password !== this.formData.confirmPassword))) {
        this.alertError.text = "Passwords don't match";
        this.alertError.visible = true;
        this.needFill = true;
        return null;
      }
      if ((this.formData.password.length !== 0) &&
        (this.formData.password.length < 6 ||
         !(/(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])/.test(this.formData.password)))) {
        this.alertError.text = 'Please, check your password. It is short or missing required characters!';
        this.alertError.visible = true;
        this.needFill = true;
        return null;
      }
      return true;
    },
    saveData() {
      const self = this;
      this.needFill = false;
      this.hasSaveError = false;
      if (!this.validateData()) {
        this.needFill = true;
        return;
      }
      // this.alertError.text = 'There were errors during the upload';
      this.upload.image = false;
      this.upload.total = 1;
      this.upload.uploaded = 0;
      this.upload.visible = true;
      this.sendCompany()
        .then((response) => {
          if (response !== 200 && response !== 201) {
            self.hasSaveError = true;
            return null;
          }
          if (this.company.id) {
            self.upload.image = false;
            return this.sendUser();
          }
          return null;
        })
        .then((response) => {
          if (response !== 200 && response !== 201) {
            self.hasSaveError = true;
            self.alertError.visible = true;
          } else {
            if (response === 201) {
              return this.sendCompany();
            }
            return 200;
          }
          return null;
        })
        .then((response) => {
          if (response !== 200 && response !== 201) {
            self.hasSaveError = true;
            self.alertError.visible = true;
            this.upload.visible = false;
            return null;
          }
          self.alertSuccess.visible = true;
          this.upload.visible = false;
          this.haveChanges = false;
          if (this.$router.history.pending) {
            this.$router.push({
              name: this.$router.history.pending.name,
              params: this.$router.history.pending.params,
            });
          }
          return null;
        })
        .catch((response) => {
          self.alertError.text = self.getErrorText(response);
          self.alertError.visible = true;
          this.upload.visible = false;
          return response;
        });
    },
    cancelData() {
      // this.haveChanges = false;
      this.$router.push({ name: 'Companies SuperUser' });
    },
    sendCompany() {
      const data = {
        name: this.company.name,
        logoff_after: this.timeToMin(this.company.logoff_after),
        manager: this.formData.id,
      };
      if (this.company.picture) {
        this.upload.image = true;
        this.upload.uploaded = 0;
        data.picture = this.company.picture;
      }
      if (!this.company.picture && !this.company.picture_url) {
        data.picture = null;
        this.upload.image = false;
      }
      const formData = new FormData();
      for (const key in data) {
        formData.append(key, data[key]);
      }
      if (!this.company.id) {
        return this.$http.post('companies/', data.picture ? formData : data,
          {
            method: 'POST',
            headers: {
              Authorization: `Token ${this.access_token}`,
            },
            // emulateJSON: true,
          })
          .then((response) => {
            if (response.status !== 201) {
              console.log(response);
              this.alertError.text = this.getErrorText(response);
              return response.status;
            }
            this.company.id = response.body.id;
            this.company.picture = '';
            this.company.picture_url = response.body.picture;
            return response.status;
          })
          .catch((response) => {
            if (response.status === 401) {
              this.onLogout();
            }
            this.alertError.text = this.getErrorText(response);
            this.alertError.visible = true;
            return response;
          });
      }
      return this.$http.patch(`companies/${this.company.id}/`, data.picture ? formData : data,
        {
          method: 'PATCH',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log(response);
            this.alertError.text = this.getErrorText(response);
            return response.status;
          }
          this.company.picture = '';
          this.company.picture_url = response.body.picture;
          return response.status;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
          this.alertError.text = this.getErrorText(response);
          this.alertError.visible = true;
          return response;
        });
    },
    sendUser() {
      const data = {
        first_name: this.formData.first_name,
        last_name: this.formData.last_name,
        password: this.formData.password,
        role: 'manager',
        username: this.formData.username,
        email: this.formData.email,
        company: this.company.id,
        phone: this.formData.phone,
      };
      if (!this.formData.id) {
        return this.$http.post('users/', data,
          {
            method: 'POST',
            headers: {
              Authorization: `Token ${this.access_token}`,
            },
            // emulateJSON: true,
          })
          .then((response) => {
            if (response.status !== 201) {
              console.log(response);
              this.alertError.text = this.getErrorText(response);
              return response.status;
            }
            this.formData.id = response.body.id;
            return response.status;
          })
          .catch((response) => {
            if (response.status === 401) {
              this.onLogout();
            }
            this.alertError.text = this.getErrorText(response);
            this.alertError.visible = true;
            return response;
          });
      }
      if (!data.password) {
        delete (data.password);
      }
      return this.$http.patch(`users/${this.formData.id}/`, data,
        {
          method: 'PATCH',
          headers: {
            Authorization: `Token ${this.access_token}`,
          },
          // emulateJSON: true,
        })
        .then((response) => {
          if (response.status !== 200) {
            console.log(response);
            this.alertError.text = this.getErrorText(response);
            return response.status;
          }
          return response.status;
        })
        .catch((response) => {
          if (response.status === 401) {
            this.onLogout();
          }
          this.alertError.text = this.getErrorText(response);
          this.alertError.visible = true;
          return response;
        });
    },
    getErrorText(response) {
      const result = `There were errors during the upload (${response.status})`;
      if (response.status === 400) {
        if (!response.body) {
          return 'Large file';
        }
        for (const key in response.body) {
          return `${key}: ${response.body[key]}`;
        }
      }
      if (response.status === 401) {
        return 'Invalid authorization, please relogin';
      }
      if (response.status === 404) {
        return 'Not found (404)';
      }
      if (response.status === 500) {
        return 'Internal server error';
      }
      return result;
    },
  },
  computed: {

  },
  watch: {
    'company.name'() {
      this.haveChanges = true;
    },
    'company.picture'() {
      this.haveChanges = true;
    },
    'formData.first_name'() {
      this.haveChanges = true;
    },
    'formData.last_name'() {
      this.haveChanges = true;
    },
    'formData.username'() {
      this.haveChanges = true;
    },
    'formData.email'() {
      this.haveChanges = true;
    },
    'formData.password'() {
      this.haveChanges = true;
    },
    'formData.phone'() {
      this.haveChanges = true;
    },
  },
  created() {
    if (this.$route.params.companyId) {
      this.company.id = this.$route.params.companyId;
      this.processLoading = true;
      this.getCompanyInfo(this.company.id)
      .then(() => {
        this.processLoading = false;
      })
      .catch(() => {
        this.processLoading = false;
      });
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/companies/companyConfig/companyConfig.component.js